/* ============================================================
   Collection Page — cp-collection.js
   Handles: filter panel toggle, search, price slider, cart modal
   Price filter fix: visible inputs show DT, hidden inputs send cents
   ============================================================ */

(function () {
  'use strict';

  /* ---- DOM refs ---- */
  const filterToggle  = document.getElementById('CpFilterToggle');
  const filterClose   = document.getElementById('CpFilterClose');
  const filterOverlay = document.getElementById('CpFilterOverlay');

  const searchInput   = document.getElementById('CpSearchInput');
  const searchClear   = document.getElementById('CpSearchClear');
  const cpGrid        = document.getElementById('CpGrid');

  const modal         = document.getElementById('CpModal');
  const modalClose    = document.getElementById('CpModalClose');
  const modalImg      = document.getElementById('CpModalImg');
  const modalTitle    = document.getElementById('CpModalTitle');
  const modalPrice    = document.getElementById('CpModalPrice');
  const modalSizes    = document.getElementById('CpModalSizes');
  const modalDetails  = document.getElementById('CpModalDetails');
  const modalAdd      = document.getElementById('CpModalAdd');
  const qtyMinus      = document.getElementById('CpQtyMinus');
  const qtyPlus       = document.getElementById('CpQtyPlus');
  const qtyVal        = document.getElementById('CpQtyVal');

  let qty = 1;
  let selectedVariantId = null;
  let debounceTimer = null;

  /* ===========================================================
     1. FILTER PANEL TOGGLE (mobile)
     =========================================================== */
  if (filterToggle && filterOverlay) {
    filterToggle.addEventListener('click', openFilter);
    if (filterClose) filterClose.addEventListener('click', closeFilter);

    filterOverlay.addEventListener('click', function (e) {
      if (e.target === filterOverlay) closeFilter();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape' && filterOverlay.classList.contains('is-open')) closeFilter();
    });
  }

  function openFilter() {
    filterOverlay.classList.add('is-open');
    document.body.style.overflow = 'hidden';
    if (filterToggle) filterToggle.setAttribute('aria-expanded', 'true');
    setTimeout(function () {
      var first = filterOverlay.querySelector('button, [href], input');
      if (first) first.focus();
    }, 320);
  }

  function closeFilter() {
    filterOverlay.classList.remove('is-open');
    document.body.style.overflow = '';
    if (filterToggle) {
      filterToggle.setAttribute('aria-expanded', 'false');
      filterToggle.focus();
    }
  }

  /* ===========================================================
     2. FILTER SECTION ACCORDIONS
     =========================================================== */
  document.querySelectorAll('[data-fs-toggle]').forEach(function (btn) {
    var body = btn.nextElementSibling;
    btn.addEventListener('click', function () {
      var expanded = btn.getAttribute('aria-expanded') === 'true';
      btn.setAttribute('aria-expanded', String(!expanded));
      if (body) body.style.display = expanded ? 'none' : '';
    });
  });

  /* ===========================================================
     3. CLIENT-SIDE SEARCH (filters visible cards by name)
     =========================================================== */
  if (searchInput && cpGrid) {
    searchInput.addEventListener('input', function () {
      var val = searchInput.value.trim();
      if (searchClear) searchClear.style.display = val ? 'flex' : 'none';
      clearTimeout(debounceTimer);
      debounceTimer = setTimeout(function () {
        filterCards(val.toLowerCase());
      }, 280);
    });
  }

  if (searchClear) {
    searchClear.addEventListener('click', function () {
      searchInput.value = '';
      searchClear.style.display = 'none';
      filterCards('');
      searchInput.focus();
    });
  }

  function filterCards(query) {
    if (!cpGrid) return;
    var cards = cpGrid.querySelectorAll('.cp-card');
    var visible = 0;
    cards.forEach(function (card) {
      var name = (card.dataset.productName || '').toLowerCase();
      var show = !query || name.includes(query);
      card.style.display = show ? '' : 'none';
      if (show) visible++;
    });

    var countEl = document.querySelector('.cp-count');
    if (countEl) countEl.textContent = visible + ' produit' + (visible !== 1 ? 's' : '');

    var emptyEl = document.getElementById('CpSearchEmpty');
    if (!emptyEl && visible === 0 && query) {
      emptyEl = document.createElement('div');
      emptyEl.id = 'CpSearchEmpty';
      emptyEl.className = 'cp-empty';
      emptyEl.innerHTML = '<div class="cp-empty-icon">🔍</div><h3>Aucun résultat pour "' + escapeHtml(query) + '"</h3><p>Essayez un autre terme.</p>';
      cpGrid.after(emptyEl);
    } else if (emptyEl && visible > 0) {
      emptyEl.remove();
    }
  }

  function escapeHtml(str) {
    return str.replace(/[&<>"']/g, function (c) {
      return ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;', "'": '&#39;' })[c];
    });
  }

  /* ===========================================================
     4. PRICE SLIDERS — two independent stacked range inputs
        Values are in DT directly (no cents conversion needed).
        The named inputs [data-price-min] and [data-price-max] are
        submitted directly as the form fields Shopify reads.
        JS only prevents min > max crossing.
     =========================================================== */
  document.querySelectorAll('.cp-price-sliders').forEach(function (wrap) {
    var form     = wrap.closest('.cp-price-form');
    if (!form) return;

    var thumbMin = wrap.querySelector('[data-range-min-thumb]');
    var thumbMax = wrap.querySelector('[data-range-max-thumb]');
    var inputMin = form.querySelector('[data-price-min]');
    var inputMax = form.querySelector('[data-price-max]');
    var rangeMax = parseFloat(wrap.dataset.rangeMax) || 500;

    if (!thumbMin || !thumbMax) return;

    function clamp(v, lo, hi) { return Math.max(lo, Math.min(hi, v)); }

    /* Sync slider → number input, prevent crossing */
    thumbMin.addEventListener('input', function () {
      var lo = parseFloat(thumbMin.value);
      var hi = parseFloat(thumbMax.value);
      if (lo > hi) { lo = hi; thumbMin.value = lo; }
      if (inputMin) inputMin.value = lo;
      updateSliderTrack(thumbMin, lo, rangeMax, false);
    });

    thumbMax.addEventListener('input', function () {
      var lo = parseFloat(thumbMin.value);
      var hi = parseFloat(thumbMax.value);
      if (hi < lo) { hi = lo; thumbMax.value = hi; }
      if (inputMax) inputMax.value = hi;
      updateSliderTrack(thumbMax, hi, rangeMax, true);
    });

    /* Sync number input → slider */
    if (inputMin) {
      inputMin.addEventListener('input', function () {
        var lo = clamp(parseFloat(inputMin.value) || 0, 0, rangeMax);
        var hi = parseFloat(thumbMax.value);
        if (lo > hi) lo = hi;
        thumbMin.value = lo;
        inputMin.value = lo;
        updateSliderTrack(thumbMin, lo, rangeMax, false);
      });
    }
    if (inputMax) {
      inputMax.addEventListener('input', function () {
        var hi = clamp(parseFloat(inputMax.value) || rangeMax, 0, rangeMax);
        var lo = parseFloat(thumbMin.value);
        if (hi < lo) hi = lo;
        thumbMax.value = hi;
        inputMax.value = hi;
        updateSliderTrack(thumbMax, hi, rangeMax, true);
      });
    }

    /* Colour the filled portion of each slider track */
    function updateSliderTrack(slider, value, max, isMax) {
      var pct = (value / max) * 100;
      if (isMax) {
        /* Max slider: fill from left up to thumb */
        slider.style.background =
          'linear-gradient(to right, #1D987C 0%, #1D987C ' + pct + '%, #e5e7eb ' + pct + '%, #e5e7eb 100%)';
      } else {
        /* Min slider: fill from thumb to right (show "used" portion to right) */
        slider.style.background =
          'linear-gradient(to right, #e5e7eb 0%, #e5e7eb ' + pct + '%, #1D987C ' + pct + '%, #1D987C 100%)';
      }
    }

    /* Init track colours */
    updateSliderTrack(thumbMin, parseFloat(thumbMin.value), rangeMax, false);
    updateSliderTrack(thumbMax, parseFloat(thumbMax.value), rangeMax, true);
  });

  /* ===========================================================
     5. CART BUTTONS — quick-add modal or direct add
     =========================================================== */
  document.querySelectorAll('.cp-cart-btn').forEach(function (btn) {
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      if (btn.disabled) return;

      var variantCount = parseInt(btn.dataset.variantCount || '1', 10);
      if (variantCount > 1) {
        openModal(btn);
      } else {
        addToCart(btn.dataset.variantId, 1, btn);
      }
    });
  });

  function addToCart(variantId, quantity, triggerEl) {
    if (!variantId) return;
    var textEl = triggerEl ? triggerEl.querySelector('.cp-cart-btn-text') : null;
    if (textEl) textEl.textContent = '…';

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ id: variantId, quantity: quantity })
    })
    .then(function (r) { return r.json(); })
    .then(function (data) {
      if (data.status) {
        alert(data.description || 'Erreur lors de l\'ajout au panier.');
        if (textEl) textEl.textContent = 'Ajouter au panier';
        return;
      }
      return fetch('/cart.js', { headers: { 'Accept': 'application/json' } });
    })
    .then(function (r) { if (r) return r.json(); })
    .then(function (cart) {
      if (!cart) return;
      var selectors = ['.cart-count','#CartCount','.js-cart-count','[data-cart-count]','.cart__count','.header__cart-count'];
      selectors.forEach(function (sel) {
        document.querySelectorAll(sel).forEach(function (el) { el.textContent = cart.item_count; });
      });
      if (textEl) textEl.textContent = '✓ Ajouté';
      setTimeout(function () { if (textEl) textEl.textContent = 'Ajouter au panier'; }, 2200);
    })
    .catch(function () { if (textEl) textEl.textContent = 'Ajouter au panier'; });
  }

  /* ===========================================================
     6. QUICK-ADD MODAL
     =========================================================== */
  function openModal(cartBtn) {
    var productUrl = cartBtn.dataset.productUrl;
    if (!productUrl || !modal) return;

    qty = 1;
    selectedVariantId = null;
    if (qtyVal) qtyVal.textContent = '1';
    if (modalSizes) modalSizes.innerHTML = '<p style="color:#6b7280;font-size:13px;text-align:center">Chargement…</p>';
    if (modalAdd) modalAdd.disabled = true;

    modal.style.display = 'flex';
    document.body.classList.add('cp-modal-open');

    fetch(productUrl + '.json')
      .then(function (r) { return r.json(); })
      .then(function (data) {
        var product = data.product;
        if (!product) return;

        if (modalImg && product.images && product.images[0]) {
          modalImg.src = product.images[0].src;
          modalImg.alt = product.title;
        }
        if (modalTitle) modalTitle.textContent = product.title;
        if (modalDetails) modalDetails.href = '/products/' + product.handle;

        var firstVar = product.variants[0];
        if (modalPrice) {
          var ph = '';
          if (firstVar.compare_at_price && parseFloat(firstVar.compare_at_price) > parseFloat(firstVar.price)) {
            ph = '<del style="color:#999;font-weight:400;font-size:15px">' + formatMoney(firstVar.compare_at_price) + '</del> ';
          }
          ph += '<strong>' + formatMoney(firstVar.price) + '</strong>';
          modalPrice.innerHTML = ph;
        }

        if (modalSizes) {
          modalSizes.innerHTML = '';
          var sizeOption = product.options.find(function (o) {
            return o.name.toLowerCase().includes('taille') ||
                   o.name.toLowerCase().includes('size') ||
                   o.name.toLowerCase().includes('pointure');
          });

          if (sizeOption && product.variants.length > 1) {
            var heading = document.createElement('p');
            heading.textContent = sizeOption.name;
            heading.style.cssText = 'font-weight:600;font-size:14px;margin:0 0 10px;text-align:center;color:#1f2937';
            modalSizes.appendChild(heading);

            product.variants.forEach(function (variant) {
              var btn = document.createElement('button');
              btn.type = 'button';
              btn.className = 'cp-modal-size-btn';
              btn.textContent = variant.option1;
              btn.dataset.variantId    = variant.id;
              btn.dataset.price        = variant.price;
              btn.dataset.comparePrice = variant.compare_at_price || '';
              if (!variant.available) { btn.disabled = true; btn.title = 'Épuisé'; }
              btn.addEventListener('click', function () {
                modalSizes.querySelectorAll('.cp-modal-size-btn').forEach(function (b) { b.classList.remove('is-selected'); });
                btn.classList.add('is-selected');
                selectedVariantId = variant.id;
                qty = 1;
                if (qtyVal) qtyVal.textContent = '1';
                if (modalAdd) modalAdd.disabled = false;
                if (modalPrice) {
                  var ph2 = '';
                  if (btn.dataset.comparePrice && parseFloat(btn.dataset.comparePrice) > parseFloat(btn.dataset.price)) {
                    ph2 = '<del style="color:#999;font-weight:400;font-size:15px">' + formatMoney(btn.dataset.comparePrice) + '</del> ';
                  }
                  ph2 += '<strong>' + formatMoney(btn.dataset.price) + '</strong>';
                  modalPrice.innerHTML = ph2;
                }
              });
              modalSizes.appendChild(btn);
            });
          } else {
            selectedVariantId = product.variants[0].id;
            if (modalAdd) modalAdd.disabled = !product.variants[0].available;
          }
        }
      })
      .catch(function () {
        if (modalSizes) modalSizes.innerHTML = '<p style="color:#dc2626;text-align:center;font-size:13px">Impossible de charger le produit.</p>';
      });
  }

  function closeModal() {
    if (!modal) return;
    modal.style.display = 'none';
    document.body.classList.remove('cp-modal-open');
    selectedVariantId = null;
    qty = 1;
  }

  if (modalClose) modalClose.addEventListener('click', closeModal);
  if (modal) modal.addEventListener('click', function (e) { if (e.target === modal) closeModal(); });
  document.addEventListener('keydown', function (e) {
    if (e.key === 'Escape' && modal && modal.style.display !== 'none') closeModal();
  });

  if (qtyMinus) qtyMinus.addEventListener('click', function () { if (qty > 1) { qty--; if (qtyVal) qtyVal.textContent = qty; } });
  if (qtyPlus)  qtyPlus.addEventListener('click',  function () { qty++; if (qtyVal) qtyVal.textContent = qty; });

  if (modalAdd) {
    modalAdd.addEventListener('click', function () {
      if (!selectedVariantId) return;
      addToCart(selectedVariantId, qty, { querySelector: function () { return { textContent: '' }; } });
      closeModal();
    });
  }

  /* ===========================================================
     7. HELPERS
     =========================================================== */
  function formatMoney(cents) {
    return (parseFloat(cents) / 100).toFixed(2).replace(/\.00$/, '') + ' DT';
  }

})();
